import { render } from "./TierRedemptionChart.vue?vue&type=template&id=54071b4d"
import script from "./TierRedemptionChart.vue?vue&type=script&lang=js"
export * from "./TierRedemptionChart.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__